<template>
	<div>
		<page-title-bar></page-title-bar>
        
			<v-container fluid grid-list-xl pt-0>
                    <app-card>
                        <v-btn color="default" @click="cancel" name="btncancel" >Terug</v-btn>
                        <v-btn color="success" @click="save" name="btnsave" class="text-xs-right" :disabled="disable">Opslaan</v-btn>
                    </app-card>
					<v-card flat>
						<v-card-text>
							<v-layout row wrap>
                                 <v-flex xs12 sm6>
									<v-text-field  label="Naam dienst" v-model="record.Title"></v-text-field>
								</v-flex>
                                <v-flex xs12 sm6></v-flex>

								<v-flex xs12 sm3>
									<span class="small pt-4 d-block">Verkoopprijs</span>
								</v-flex>
								<v-flex xs12 sm2>
									<v-text-field  label="Incl BTW" v-model="record.Price"></v-text-field>
								</v-flex>
                                <v-flex xs1 sm1>
									<v-select  hide-details v-bind:items="itemsVat"  v-model="vat"  label="Btw"  single-line menu-props="auto"  ></v-select>
								</v-flex>
								<v-flex xs12 sm6></v-flex>

								 <v-flex xs12 sm3>
									<span class="small pt-4 d-block">Categorie</span>
								</v-flex>
								<v-flex xs12 sm3>
									<v-select  hide-details v-bind:items="cats"  v-model="record.CategoryID"  label="Categorie"  single-line menu-props="auto" item-value="CategoryID" item-text="Descr" ></v-select>
								</v-flex>
								<v-flex xs12 sm6></v-flex>

                                <v-flex xs12 sm3>
									<span class="small pt-4 d-block">Inwerktijd (minuten)</span>
								</v-flex>
								<v-flex xs12 sm3>
									<v-text-field  label="In minuten" v-model="record.IntDuration"></v-text-field>
								</v-flex>
                                <v-flex xs12 sm6></v-flex>

                                <v-flex xs12 sm3>
									<span class="small pt-4 d-block">Pauzetijd (minuten)</span>
								</v-flex>
								<v-flex xs12 sm3>
									<v-text-field  label="In minuten" v-model="record.IntWait"></v-text-field>
								</v-flex>
                                <v-flex xs12 sm6></v-flex>

								<v-flex xs12 sm3>
									<span class="small pt-4 d-block">Online gebruiken</span>
								</v-flex>
								<v-flex xs12 sm3>
									<v-checkbox color="primary" label="Online gebruiken" v-model="record.IsUseOnline"></v-checkbox>
								</v-flex>
								<v-flex xs12 sm6></v-flex>

								<v-flex xs12 sm3>
									<span class="small pt-4 d-block">Blokkeer keuze medewerker online<br>Klant kan in dit geval geen medewerker of ruimte kiezen<br>
									Het systeem gaat van links naar rechts in de agenda kijken naar een vrije plaats</span>
								</v-flex>
								<v-flex xs12 sm3>
									<v-checkbox color="primary" label="Blokkeer keuze" v-model="record.IsBlockUserChoice"></v-checkbox>
								</v-flex>
                                <v-flex xs12 sm6></v-flex>

								<v-flex xs12 sm3>
									<span class="small pt-4 d-block">Enkel in pakketvorm online boeken<br>
									Deze behandeling kan niet afzonderlijk geboekt worden.</span>
								</v-flex>
								<v-flex xs12 sm3>
									<v-checkbox color="primary" label="Enkel in pakketvorm" v-model="record.IsOnlyInPackage"></v-checkbox>
								</v-flex>
                                <v-flex xs12 sm6></v-flex>
								

                                <v-flex xs12 sm3>
									<span class="small pt-4 d-block">Kleur in agenda</span>
								</v-flex>
								<v-flex xs12 sm3>
									<swatches v-model="color"  colors= "material-basic" shapes="circles"></swatches>
								</v-flex>
								
                                <v-flex xs12 sm6></v-flex>
								
							</v-layout>
						</v-card-text>
					</v-card>
			
		</v-container>
	</div>
</template>

<script>

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

import Swatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.min.css";

export default {
   props: {
	   id : String,
	   cats : Array,
       isNew : Boolean
    },
  data() {
    return {
        loader: true,
        disable: false,
		record: {},
		items: [],
		itemsVat: [0,6,12,21],
		color: '#EEEEEE',
		vat: 0
    };
  },
   components: {
	   Swatches
  },
  mounted() {
	this.vat =21;
	this.getTableData();
	console.log (this.cats);
  },
  methods: {
    cancel ()  {
        router.go (-1);
    },
    save () {
		this.record.ArtColorStr = this.color;
		this.setVat (this.vat);
        myHttpApi.post('BOProduct/SaveService', this.record)
        .then(response => {
            this.loader = false;
            this.disable = true;
        })
        .catch(error => {
            console.log(error);
        });
	},
	getVat (vatId){
		if (vatId == 0) {this.vat = 0;}
		if (vatId == 1) {this.vat = 6;}
		if (vatId == 2) {this.vat = 12;}
		if (vatId == 3) {this.vat = 21;}
		if (vatId == 4) {this.vat = 9;}
	},
	setVat (vatId){
		if (vatId == 0) {this.record.vatID = 0;}
		if (vatId == 6) {this.record.vatID = 1;}
		if (vatId == 12) {this.record.vatID = 2;}
		if (vatId == 21) {this.record.vatID = 3;}
		if (vatId == 9) {this.record.vatID = 4;}
	},
	getTableData() {
      myHttpApi
		const searchRec = {Search: this.id, Extra: ""}
		myHttpApi.post('BOProduct/GetService', searchRec)
        .then(response => {
		  this.loader = false;
		  this.color = response.data.ArtColorStr;
		  this.getVat (response.data.VatID);
		  if (this.isNew)
		  {
			  this.vat = 21;
		  }
		  //if (this.color.length <= 3) {this.color = "#EEEEEE";}
		  //if (this.color = "#FFFFFF") {this.color = "#EEEEEE";}
          this.record = response.data;
        })
        .catch(error => {
          console.log(error);
        });
	}
  }
};
</script>

